(function (app) {
    app.constant("prefixes",
    [
        "Mr",
        "Mrs",
        "Ms",
        "Miss",
        "Dr"
    ]);
})(window.app); //jshint ignore:line